// extracted by mini-css-extract-plugin
module.exports = {"otpGroup":"OtpInput_otpGroup__BpflU","otpInput":"OtpInput_otpInput__KvJnf"};